import { z } from "zod";

export const supportRequestSchema = z.object({
  siteId: z.number(),
  comment: z.string(),
  requesterPhoneNumber: z.string(),
  requesterEmail: z.string(),
});

export type TSupportRequest = z.infer<typeof supportRequestSchema>;
